import { Outlet, useLocation } from 'react-router';
import AnalyticsRoot from '@/components/AnalyticsRoot';
import AgeGate from '@/components/AgeGate';
import AppShell from '@/components/AppShell';
import ConfirmHost from '@/components/ConfirmDialog';
import LeaveGuard from '@/components/LeaveGuard';
import ReauthDialog from '@/components/ReauthDialog';

/**
 * Wraps every route, so chrome, instrumentation and the age gate are impossible to forget — and
 * the three things any screen may need without owning: the sign-in that rescues a lapsed
 * session, the guard on unsaved work, and the question before an action that cannot be undone.
 * The console asks its questions in its own dialog, so the public one stands down under `/x/`.
 */
export default function Root() {
  const { pathname } = useLocation();
  return (
    <>
      <AnalyticsRoot />
      <AgeGate />
      <AppShell>
        <Outlet />
      </AppShell>
      <LeaveGuard />
      <ReauthDialog />
      {pathname.startsWith('/x/') ? null : <ConfirmHost />}
    </>
  );
}
